// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZQdMh","name":"styles_name__19L62","phone":"styles_phone__2M8UZ"};